import { HStack, Image, Text } from "@chakra-ui/react";
import { SealCheckThickIcon } from "../../icons/SealCheckThickIcon";

export function Eyebrow({
  text,
  imageUrl,
}: {
  text: string;
  imageUrl?: string;
}) {
  if (imageUrl) {
    return (
      <Image
        src={imageUrl}
        alt={text}
        height="96px"
        mt="-20px"
        mb="-24px"
      />
    );
  }

  return (
    <HStack
      gap={4}
      px={2}
      py={1}
      alignItems="center"
      borderRadius="full"
      backdropFilter="blur(6px)"
      backgroundColor="blaze.blaze_20"
      border="1px solid"
      borderColor="blaze.blaze"
    >
      <SealCheckThickIcon boxSize={4} color="blaze.blaze" />
      <Text variant="paymentEyebrow">{text}</Text>
    </HStack>
  );
}
